import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  Table,
  Tooltip,
  Divider,
  Popconfirm,
  Carousel,
  Menu,
  Dropdown,
  Modal,
  Tag,
  Popover,
} from "antd";
import classNames from "classnames";
import _ from "lodash";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
  DownOutlined,
  ExclamationCircleOutlined,
  LeftCircleOutlined,
  LoadingOutlined,
  QuestionCircleOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import ScModalCore from "../../feedback/scModalCore";
import "../../../assets/stylus/com/display/grid.styl";
import fetchHandler from "../../../fetch/fetchHandler";
import { initGrids, initModals } from "../../../state/action/comAction";
import { TableLocale } from "../../../utils/publicParam";
import functionTools from "../../../utils/Tool";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class gridTable extends PureComponent {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.gridTableCore;
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.empty = {
      emptyText: this.internationalization.wz1, // '暂无数据'
    };
    this.actionWrap = [];
    this.isAsyncTable = !1;
    console.log((this.props.config.tableParam && this.props.config.tableParam.pageCount) || 10);
    this.state = {
      noPagination: !!this.props.config.noPagination,
      loading: !1,
      gridData: null,
      expandedRowKeys: [],
      rowDescription: "",
      modalConfirmVisible: false,
      // dropDownVisible: false,
      modalParams: null,
      onModalConfirm: null,
      // 当前的列信息
      currentColumns: [],
      pagination: this.props.config.noPagination
        ? false
        : {
            current: 1,
            total: 0,
            // hideOnSinglePage:true, // 只有1页时隐藏分页
            pageSize:
              (this.props.config.tableParam && this.props.config.tableParam.pageCount) || 10,
            showTotal: (total) => (this.props.unTotalMode
                ? ""
                : `${this.internationalization.msg1}${total}${this.internationalization.msg1_2}`),
            onShowSizeChange: (current) => {
              this.turnPage(current);
            },
            onChange: (current) => {
              this.turnPage(current);
            },
          },
    };
    this.params = this.state.noPagination
      ? {}
      : {
          page: 1,
          pagecount: (this.props.config.tableParam && this.props.config.tableParam.pageCount)
          || 10, // pagecount默认请求每页数量
        };
    if (this.props.config.tableParam.pageCount === false) {
      this.params = _.omit(this.params, ["pagecount", "page"]);
      this.props.config.tableParam = _.omit(this.props.config.tableParam, ["pagecount"]);
    }
  }

  resolveColumns(columns) {
    const finalCols = [];
    columns.forEach((c) => {
      switch (c.colType) {
        case "textCol":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            dataIndex: c.key,
            key: c.key,
            align: c.align,
            width: c.width,
            ...(c.fix && {
              fixed: c.fix,
              width: c.width,
            }),
            ...(c.render && {
              render: c.render,
            }),
            ...(c.sorter && {
              sorter: c.sorter,
              sortDirections: c.sortDirections ? c.sortDirections : ["ascend", "descend"],
              showSorterTooltip: false,
            }),
          });
          break;
        case "tipCol":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            dataIndex: c.key,
            key: c.key,
            className: "column-nowrap",
            align: "left",
            render: (text, record) => this.showMoreTip(
                c.render ? c.render(text, record) : text,
                c.perchCondition ? c.perchCondition(record) : true,
                c.tipNum ? c.tipNum : 10,
              ),
            ...(c.fix && {
              fixed: c.fix,
              width: c.width,
            }),
          });
          break;
        case "numCol":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            dataIndex: c.key,
            key: c.key,
            align: "center",
            render: (text) => (
              <span className="sc-column-num">{c.render ? c.render(text) : text}</span>
            ),
            ...(c.fix && {
              fixed: c.fix,
              width: c.width,
            }),
          });
          break;
        case "thumbImage":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            dataIndex: c.key,
            key: c.key,
            align: "center",
            render: this.generateThumbImageAction,
            ...(c.fix && {
              fixed: c.fix,
            }),
          });
          break;
        case "action":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            key: c.key,
            align: c.align || "center",
            render: this.generateActionWrap(c.actionMap),
            fixed: c.fix || "right",
            width: c.width || 120,
          });
          break;
        case "tag":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            key: c.key,
            align: c.align || "center",
            render: this.generateTags(c),
            width: c.width || 120,
            ...(c.fix && {
              fixed: c.fix,
            }),
          });
          break;
        case "popover":
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            key: c.key,
            align: c.align || "center",
            render: this.generatePopover(c),
            width: c.width || 120,
            ...(c.fix && {
              fixed: c.fix,
            }),
          });
          break;
        default:
          finalCols.push({
            title: c.message ? (
              <Popover content={c.message}>
                {c.name} <QuestionCircleOutlined style={{ marginLeft: "10px" }} />
              </Popover>
            ) : (
              c.name
            ),
            dataIndex: c.key,
            key: c.key,
            align: c.align || "left",
          });
      }
    });
    return finalCols;
  }

  componentWillMount() {
    console.log(this.state.noPagination);
    console.log("---------------------------------------------------table will mount");
    this.isStaticData = typeof this.props.config.dataApi !== "function";
    this.isAsyncTable = this.props.config.tableColumns[0].colType === "asyncFields";
    this.currentColumns = this.resolveColumns(this.props.config.tableColumns);
    if (this.props.config.autoRefresh) {
      this.fetchData(!0, { ...this.params, ...this.props.config.tableParam });
    }
    // 更新注入grid相关信息状态
    console.log("--initGrids--params--", this.params);
    console.log("tableKey", this.props.config.tableKey);
    this.context.store.dispatch(
      initGrids(this.props.config.tableKey, this.params, this.fetchData, this),
    );
    console.log(this.context.store.getState().gridsInfo);
    // let data=[{name:'null',title:null,action:1},{name:'null',title:null,action:2}]
    // this.filterJsonNull(data)
  }

  componentWillReceiveProps(nextProps) {
    // dataApi为接口函数时，不可执行下列事件
    if (this.isStaticData) {
      console.log("loop");
      this.setState({
        gridData: [...nextProps.config.dataApi],
        pagination: this.state.pagination,
      });
    }
  }

  // 设置pop浮窗显示
  // condition做条件判断显示
  showMoreTip(textStr, condition, tipNum) {
    if (textStr && textStr.toString().split("").length >= tipNum) {
      return (
        <Tooltip
          placement="bottom"
          overlayClassName="sc-tooltip"
          arrowPointAtCenter
          title={
            textStr.indexOf("\\n") !== -1 ? (
              <div dangerouslySetInnerHTML={{ __html: textStr.replace(/\\n/g, "</br>") }}></div>
            ) : (
              <p>{textStr}</p>
            )
          }>
          {`${textStr.replace(/\\n/g, "").substring(0, tipNum)}...`}
        </Tooltip>
      );
    } else {
      return textStr && condition ? `${textStr}`.replace(/\\n/g, "") : "--";
    }
  }

  // 打开cloumnDtail显示
  // openColumnDetail (textStr, tipKey) {
  //   const openRowKeys = [tipKey];
  //   this.setState({
  //     expandedRowKeys: [...openRowKeys],
  //     rowDescription: textStr
  //   });
  // }

  // 构建图片预览交互
  generateThumbImageAction = (text) => {
    if (functionTools.notNull(text)) {
      return (
        <img
          alt=""
          onClick={() => this.openThumbModal(text && text.toString(), 0)}
          src={text && text.toString().split(",")[0]}
        />
      );
    }
    return <span>{this.internationalization.msg2}</span>;
  };

  // 构建标签
  generateTags(c) {
    // 每个字段配置项内容
    return (record) => {
      // 配置行每个字段值
      if (functionTools.notNull(c.key && record[c.key])) {
        return (
          <span>
            {record[c.key].map((tag, index) => (
              <Tag color={`#${tag.color}`} key={tag.color + index}>
                <span>{tag.text}</span>
              </Tag>
            ))}
          </span>
        );
      }
      return <span>{this.internationalization.msg2}</span>;
    };
  }

  // 构建气泡卡片
  generatePopover = () => {
    // return (record)=> { //配置行每个字段值
    //     if (functionTools.notNull(c.key&&record[c.key])) {
    //         return <span>
    //                {record[c.key].map((tag, index)=> (
    //                    <Tag color={'#' + tag.color} key={tag.color + index}>
    //                        {tag.text}
    //                    </Tag>
    //                ))}
    //          </span>
    //     }
    //     return <span>暂无</span>
    // }
  };

  next() {
    this.slider.slick.slickNext();
  }

  prev() {
    this.slider.slick.slickPrev();
  }

  openThumbModal(urls) {
    // 预栏的实现请参考模态窗口组件
    const thumbDom = [];
    if (urls.split(",") && urls.split(",").length > 1 && urls.split(",")[1] !== "") {
      for (const i of urls.split(",")) {
        if (i.length) {
          thumbDom.push(
            <div key={i}>
              <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                <LeftCircleOutlined style={{ fontSize: 50 }} onClick={this.prev} />
                <h3 style={{ marginBottom: 0 }}>
                  <img
                    alt=""
                    src={i}
                    style={{
                      margin: "auto",
                      width: "95%",
                    }}
                  />
                </h3>
                <RightCircleOutlined style={{ fontSize: 50 }} onClick={this.next} />
              </div>
            </div>,
          );
        }
      }
    } else {
      for (const i of urls.split(",")) {
        if (i.length) {
          thumbDom.push(
            <div key={i}>
              <h3 style={{ marginBottom: 0 }}>
                <img
                  alt=""
                  src={i}
                  style={{
                    margin: "auto",
                    width: "100%",
                  }}
                />
              </h3>
            </div>,
          );
        }
      }
    }
    const settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      cssEase: "linear",
    };

    this.content = (
      <div>
        <Carousel {...settings} className="carousel-center" ref={(el) => (this.slider = el)}>
          {thumbDom}
        </Carousel>
      </div>
    );
    this.setState(
      {
        modalConfig: {
          key: `thumbModal${new Date().getTime().toString()}`,
          width: 600, // 自定义模态框宽度
          title: this.internationalization.msg3, // 预览图片', // 模态窗口的标题
          content: this.content, // 自定义 jsx内容
        },
      },
      () => {
        this.context.store.dispatch(initModals(this.state.modalConfig.key));
      },
    );
  }

  // 构建action wrap
  generateActionWrap(actions) {
    return (text, record) => {
      const btns = [];
      return (
        <div className="action-wrap">
          {actions.map((item, index) => {
            const res = JSON.parse(JSON.stringify(record).replace(/---/g, ""));
            let divider;
            if (item.actionName && index !== 0) {
              if (actions[index - 1] && actions[index - 1].actionName) {
                divider = <Divider type="vertical" />;
              } else if (actions[index - 2] && actions[index - 2].actionName) {
                divider = <Divider type="vertical" />;
              } else if (actions[index - 3] && actions[index - 3].actionName) {
                divider = <Divider type="vertical" />;
              } else {
                divider = null;
              }
            }
            const newActionName =
              typeof item.render === "function" && item.render(text, res)
                ? item.render(text, res)
                : item.actionName;
            let poptitle = null;
            if (item.popText) {
              poptitle = item.popText(res);
            } else {
              poptitle =
                this.internationalization.msg4 + newActionName + this.internationalization.msg4_2;
            }
            const popConfirm = (
              <Popconfirm
                key={`${index}confirm`}
                title={poptitle}
                onConfirm={() => {
                  item.handler(res);
                }}
                okText={this.internationalization.btn1}
                cancelText={this.internationalization.btn2}>
                <a
                  href="javascript:void(0);"
                  key={`${index}confirm-href`}
                  title={newActionName.length >= 4 ? newActionName : ""}>
                  {newActionName}
                </a>
              </Popconfirm>
            );
            const modalConfirm = (
              <a
                href="javascript:void(0);"
                key={`${index}confirm-href`}
                title={newActionName}
                onClick={() => {
                  this.setState({
                    modalConfirmVisible: true,
                    modalContent: poptitle,
                    onModalConfirm: item,
                    modalParams: res,
                  });
                }}>
                {newActionName}
              </a>
            );
            if (actions.length > 4 && index > 2) {
              // console.log("item.type----", item.type);
              const innerJsx =
                (item.render && !item.render(text, res)) ||
                (item.disabled && item.disabled(text, res)) ? (
                  <span className="disabled">{item.actionName}</span>
                ) : (
                  <span key={`${index}actionWrap`}>
                    {item.type === "href" ? (
                      <a
                        href="javascript:void(0)"
                        key={`${index}href`}
                        title={newActionName.length >= 4 ? newActionName : ""}
                        onClick={() => {
                          item.handler(res);
                        }}>
                        {item.actionName}
                      </a>
                    ) : (
                      item.type === "confirm" && modalConfirm
                    )}
                  </span>
                );
              // innerJsx加入下拉菜单组
              btns.push(
                <Menu.Item key={index} className="sc-more-btn">
                  {innerJsx}
                </Menu.Item>,
              );
            } else {
              return (item.render && !item.render(text, res)) ||
                (item.disabled && item.disabled(text, res)) ? (
                <span key={`${index}actionWrap`} className="disabled">
                  {divider}
                  {item.actionName}
                </span>
              ) : (
                <span key={`${index}actionWrap`}>
                  {divider}
                  {item.type === "href" ? (
                    <a
                      href="javascript:void(0)"
                      key={`${index}href`}
                      title={newActionName.length >= 4 ? newActionName : ""}
                      onClick={() => {
                        item.handler(res);
                      }}>
                      {newActionName}
                    </a>
                  ) : (
                    item.type === "confirm" && popConfirm
                  )}
                </span>
              );
            }
            return true;
          })}
          {btns.length ? (
            <span key="more_actionWrap">
              <Divider type="vertical" />
              <Dropdown overlay={<Menu>{btns}</Menu>} placement="bottomLeft" trigger={["click"]}>
                <a className="ant-dropdown-link" href="#">
                  {this.internationalization.btn3}
                  <DownOutlined />
                </a>
              </Dropdown>
            </span>
          ) : (
            ""
          )}
        </div>
      );
    };
  }

  // 获取列表数据
  fetchData(isInit, params) {
    console.log("--fentchData--", params);
    console.log("--fentchData--", this.params);
    if (this.state.noPagination && (this.params.page || this.params.pageCount)) {
      console.log("00000000000000000000000");
      delete this.params.page;
      delete this.params.pagecount;
      console.log("--fentchData--", this.params);
    }
    console.log("--fentchData--", this.params);
    // 默认参数和外部传入参数合并
    this.params = Object.assign(this.params, params);
    // 判断是否需要重置页码
    if (!this.state.noPagination) {
      if (isInit) {
        this.state.pagination.current = 1;
        this.params.page = 1;
        this.state.pagination.total = 0;
      }
    }

    //

    if (!this.isStaticData) {
      this.beginLoading();
      return fetchHandler(this.props.config.dataApi, this.params).then((res) => {
        if (res && res.code === "success") {
          if (typeof this.props.transformData === "function") {
            res.data = this.props.transformData(res.data);
          }

          // 判断是否存在异步构造table column
          if (this.isAsyncTable && res.data.fields) {
            const renderFields = this.props.config.tableColumns[0].fields;
            this.state.currentColumns = [];
            for (const f of res.data.fields) {
              let tmpColumn = {
                title: f.name,
                dataIndex: f.key === "id" ? "key" : f.key,
                key: f.key === "id" ? "key" : f.key,
              };
              if (renderFields) {
                const renderField = _.find(renderFields, (r) => {
                  return r.key === f.key;
                });
                tmpColumn = Object.assign(tmpColumn, renderField);
              }
              this.state.currentColumns.push(tmpColumn);
            }
            this.state.currentColumns = this.state.currentColumns.concat(
              this.resolveColumns(this.props.config.tableColumns),
            );
            this.setState(
              {
                currentColumns: [...this.state.currentColumns],
              },
              () => {
                console.log(this.state.currentColumns);
              },
            );
          }
          this.endLoading(res, params);
        } else {
          this.endLoading(res, params);
        }
        if (res.code === "no_data") {
          const pageNation = "pagination[total]";
          this.state.pagination.current = 1;
          this.params.page = 1;
          this.setState({
            [pageNation]: 0,
          });
        }
        return res;
      });
    } else {
      this.setState({
        gridData: [...this.props.config.dataApi],
        pagination: this.state.pagination,
      });
    }
  }

  // 跳转页码
  turnPage(current) {
    this.params["page"] = parseInt(current);
    this.state.pagination.current = parseInt(current);
    this.fetchData(!1, { ...this.params, isBtnSearch: false, ...this.props.config.tableParam });
  }

  // 开始loading
  beginLoading() {
    this.setState({
      loading: !0,
    });
  }

  // 结束loading
  endLoading(res, params) {
    console.log(res);
    if (this.state.noPagination && !this.props.unTotalMode) {
      //
      // 如果返回的数据满额 并且这一页的数据没有累加过（即当前点击的页码*pageSize > 已经存在的total总量） 则认为有下一页，total累加
      // 正常模式
      res.data = this.props.transformData
        ? this.props.transformData(res.data, this.state.pagination)
        : res.data;

      if (this.props.config.dataPath && this.props.config.dataPath.length > 0) {
        let findFinallyData = res.data;

        if (findFinallyData) {
          for (const rd of this.props.config.dataPath) {
            findFinallyData = findFinallyData[rd];
          }
        }
        this.setState({
          loading: !1,
          gridData: findFinallyData && findFinallyData.length > 0 ? findFinallyData : [],
        });
      } else {
        this.setState({
          loading: !1,
          gridData: res.data && res.data.length > 0 ? res.data : null,
        });
      }
    } else {
      const { pagination } = this.state;
      const { unTotalMode } = this.props;
      // 处理total逻辑
      let total = pagination.total;
      if (params.isBtnSearch) {
        this.setState(
          {
            pagination: {
              ...this.state.pagination,
              total: 0,
            },
          },
          () => {
            total = this.state.pagination.total;
          },
        );
      }
      //
      // 如果返回的数据满额 并且这一页的数据没有累加过（即当前点击的页码*pageSize > 已经存在的total总量） 则认为有下一页，total累加
      if (
        unTotalMode &&
        res.data &&
        res.data.length === pagination.pageSize &&
        pagination.current * pagination.pageSize > total
      ) {
        total += pagination.pageSize;
      }
      // if (unTotalMode) {
      //     if (total === 0) {
      //         this.setState({
      //             noPagination: true
      //         })
      //     } else {
      //         this.setState({
      //             noPagination: false
      //         })
      //     }
      // }

      // 正常模式
      if (!unTotalMode) {
        total = res.pageLimit && res.pageLimit.totalCount;
      }

      res.data = this.props.transformData
        ? this.props.transformData(res.data, this.state.pagination)
        : res.data;

      if (this.props.config.dataPath && this.props.config.dataPath.length > 0) {
        let findFinallyData = res.data;

        if (findFinallyData) {
          for (const rd of this.props.config.dataPath) {
            findFinallyData = findFinallyData[rd];
          }
        }
        this.setState({
          loading: !1,
          gridData: findFinallyData && findFinallyData.length > 0 ? findFinallyData : [],
          pagination: {
            ...this.state.pagination,
            total,
          },
        });
      } else {
        this.setState({
          loading: !1,
          gridData: res.data && res.data.length > 0 ? res.data : null,
          pagination: {
            ...this.state.pagination,
            total,
          },
        });
      }
    }
  }

  filterJsonNull(data) {
    JSON.parse(
      JSON.stringify(data).replace(/["n]ul[l"]/g, (a, b, c, d) => {
        console.log(a, b, c, d);
        return '"---"';
        // if(typeof c ==='string'){
        //   return '---'
        // }else{
        //   return '"---"'
        // }
      }),
    );
  }

  // 模态框
  hideModal = () => {
    const res = this.state.modalParams;
    if (this.state.onModalConfirm) {
      this.state.onModalConfirm.handler(res);
    }
    this.setState({
      modalConfirmVisible: false,
    });
  };

  render() {
    const className = classNames({
      "sc-table": !0,
      // 'table-center': this.props.postyle || 'table-center',
      // 'JStableRow-bg':this.props.changeBG
    });
    if (this.state.gridData) {
      this.state.gridData.forEach((item) => {
        for (const key in item) {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            if (key === "id") {
              item.key = item.id;
              delete item.id;
            }
            if (item[key] === null) {
              item[key] = "--";
            }
          }
        }
      });
    }
    console.log("this.state.gridData", this.state.gridData);
    console.log(this.currentColumns);
    // const showTotal = () => `共计${showTotal}条`;
    return (
      <div>
        {this.isAsyncTable ? (
          <div className="async-table">
            {!this.state.loading && this.state.gridData ? (
              <div>
                {this.state.noPagination ? (
                  <div className="noPagination">
                    <Table
                      showSorterTooltip
                      className={className}
                      dataSource={this.state.gridData}
                      columns={this.state.currentColumns}
                      locale={TableLocale}
                      loading={this.state.loading}
                      rowClassName={(record) => {
                        if (this.props.config.changeClass) {
                          return record[this.props.config.changeClass.mapKey] ===
                            this.props.config.changeClass.condition
                            ? this.props.config.changeClass.yesClass
                            : this.props.config.changeClass.noClass;
                        }
                      }}
                      pagination={false}
                      scroll={{ x: "100%" }}
                      onChange={this.props.config.tableChange}
                      footer={
                        this.state.gridData
                          ? () => (this.props.config.tableInfo ? (
                                this.props.config.tableInfo.footer
                              ) : (
                                <div></div>
                              ))
                          : null
                      }
                      rowSelection={
                        this.props.config.tableInfo && this.props.config.tableInfo.hasRow
                          ? this.props.config.tableInfo.rowSelection
                          : null
                      }
                      {...this.props}
                    />
                  </div>
                ) : (
                  <Table
                    showSorterTooltip
                    className={className}
                    dataSource={this.state.gridData}
                    columns={this.state.currentColumns}
                    locale={TableLocale}
                    pagination={
                      this.state.pagination.total > 0
                        ? {
                            showSizeChanger: false,
                            ...this.state.pagination,
                            total: this.props.unTotalMode
                              ? this.state.pagination.total + 1
                              : this.state.pagination.total,
                          }
                        : null
                    }
                    loading={this.state.loading}
                    rowClassName={(record) => {
                      if (this.props.config.changeClass) {
                        return record[this.props.config.changeClass.mapKey] ===
                          this.props.config.changeClass.condition
                          ? this.props.config.changeClass.yesClass
                          : this.props.config.changeClass.noClass;
                      }
                    }}
                    scroll={{ x: "100%" }}
                    onChange={this.props.config.tableChange}
                    footer={
                      this.state.gridData
                        ? () => (this.props.config.tableInfo ? (
                              this.props.config.tableInfo.footer
                            ) : (
                              <div></div>
                            ))
                        : null
                    }
                    rowSelection={
                      this.props.config.tableInfo && this.props.config.tableInfo.hasRow
                        ? this.props.config.tableInfo.rowSelection
                        : null
                    }
                    {...this.props}
                  />
                )}
              </div>
            ) : null}
            {!(!this.state.loading && this.state.gridData) && !this.state.loading ? (
              <div className="async-generating">
                <ExclamationCircleOutlined />
                {this.internationalization.msg5}
              </div>
            ) : (
              <div className="async-generating">
                <LoadingOutlined />
                {this.internationalization.msg6}...
              </div>
            )}
          </div>
        ) : (
          <div>
            {this.state.noPagination ? (
              <div className="noPagination">
                <Table
                  showSorterTooltip
                  className={className}
                  dataSource={this.state.gridData}
                  columns={this.currentColumns}
                  locale={TableLocale}
                  loading={this.state.loading}
                  rowClassName={(record) => {
                    if (this.props.config.changeClass) {
                      return record[this.props.config.changeClass.mapKey] ===
                        this.props.config.changeClass.condition
                        ? this.props.config.changeClass.yesClass
                        : this.props.config.changeClass.noClass;
                    }
                  }}
                  pagination={false}
                  scroll={{ x: "100%" }}
                  onChange={this.props.config.tableChange}
                  footer={
                    this.state.gridData
                      ? () => (this.props.config.tableInfo ? (
                            this.props.config.tableInfo.footer
                          ) : (
                            <div></div>
                          ))
                      : null
                  }
                  rowSelection={
                    this.props.config.tableInfo && this.props.config.tableInfo.hasRow
                      ? this.props.config.tableInfo.rowSelection
                      : null
                  }
                  {...this.props}
                />
              </div>
            ) : (
              <Table
                showSorterTooltip
                className={className}
                dataSource={this.state.gridData}
                columns={this.currentColumns}
                locale={TableLocale}
                pagination={
                  this.state.pagination.total > 0
                    ? {
                        showSizeChanger: false,
                        ...this.state.pagination,
                        total: this.props.unTotalMode
                          ? this.state.pagination.total + 1
                          : this.state.pagination.total,
                      }
                    : null
                }
                loading={this.state.loading}
                rowClassName={(record) => {
                  if (this.props.config.changeClass) {
                    return record[this.props.config.changeClass.mapKey] ===
                      this.props.config.changeClass.condition
                      ? this.props.config.changeClass.yesClass
                      : this.props.config.changeClass.noClass;
                  }
                }}
                scroll={{ x: "100%" }}
                onChange={this.props.config.tableChange}
                footer={
                  this.state.gridData
                    ? () => (this.props.config.tableInfo ? (
                          this.props.config.tableInfo.footer
                        ) : (
                          <div></div>
                        ))
                    : null
                }
                rowSelection={
                  this.props.config.tableInfo && this.props.config.tableInfo.hasRow
                    ? this.props.config.tableInfo.rowSelection
                    : null
                }
                {...this.props}
              />
            )}
          </div>
        )}
        {this.state.modalConfig && <ScModalCore config={this.state.modalConfig}></ScModalCore>}

        <Modal
          className="table-modal-confirm"
          title={this.state.modalConfirmVisible}
          width="280px"
          visible={this.state.modalConfirmVisible}
          onOk={this.hideModal}
          onCancel={() => {
            this.setState({
              modalConfirmVisible: false,
            });
          }}>
          <span>{this.state.modalContent}</span>
        </Modal>
      </div>
    );
  }
}

export default injectIntl(gridTable);

gridTable.propTypes = {
  config: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/AntD/components/display/table/gridTableCore.js